import script from "./GlobalPresenceSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalPresenceSection.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalPresenceSection.vue?vue&type=style&index=0&id=5433a0c4&lang=scss"

const __exports__ = script;

export default __exports__